import axios from 'axios';
import store from '../store/store';
import { authLogout } from '../store/authSlice';
import { API_URL } from '../config';

const api = async (options) => {
    try {
        const result = await axios(options);
        if(result.data.error) {
            throw new Error('error.api' + result.data.error.code);
        }
        return { data: result.data };
    } catch (error) {
        let message = 'error.unknown';
        if(error.response) {
            // Это ошибка axios
            message = 'error.http' + error.response.status;
            if(error.response.status === 401) {
                // Нужна авторизация
                delete axios.defaults.headers.common['Authorization'];
                document.body.removeAttribute('scheme');
                store.dispatch(authLogout());
            }
        } else if(error.message) {
            // Это ошибка из приложения сервера
            message = error.message;
        }
        return { error: message };
    }
};

export const get = async (method, data) => {
    return await api({
        method: 'get',
        url: API_URL + method,
        params: data
    });
};

export const post = async (method, data) => {
    return await api({
        method: 'post',
        url: API_URL + method,
        data
    });
};

export const put = async (method, data) => {
    return await api({
        method: 'put',
        url: API_URL + method,
        data
    });
};

export const del = async (method, data) => {
    return await api({
        method: 'delete',
        url: API_URL + method,
        data
    });
};
